export const reportsColumns = (t: any) => [
    {
        key: "name",
        name: t('reports.columns.name'),
        fieldName: "name",
        minWidth: 250,
        maxWidth: 300,
        isResizable: true,
    },
    {
        key: "description",
        name: t('reports.columns.description'),
        fieldName: "description",
        minWidth: 350,
        maxWidth: 500,
        isResizable: true,
    },
];